import React from 'react';
import PropTypes from "prop-types";
import { useTranslation } from 'react-i18next';

import { connect } from "react-redux";
import { patchLocationLink } from 'redux/location-links/actions';
import { setLastPatchedId } from 'redux/common/actions';

import CommonInputField from 'components/elements/inputs/CommonInputField';

import './LocationLinkTitle.css';


function LocationLinkTitle(props) {
  const {
    patchLocationLink,
    setLastPatchedId,
    linkItem,
    patchLocationLinkError,
    lastPatchedId,
  } = props;
  const { t } = useTranslation();

  const validation = value => {
    if (!value) {
      return t("Link title should not be empty");
    }
    if (value) {
      if (value.length > 128) {
        return t("Ensure this field has no more than 128 characters");
      }
    }
    return null;
  };

  return (
    <div className="location-link-title__component">
      <CommonInputField
        key={`location-link-title-input-key-${linkItem.id}`}
        editIcon
        initialValue={linkItem.title}
        executedFunction={value => {
          const form = new FormData();
          form.append('title', value);
          patchLocationLink(linkItem.id, form);
          setLastPatchedId(linkItem.id);
        }}
        serverErrors={
          lastPatchedId === linkItem.id &&
          patchLocationLinkError &&
          patchLocationLinkError.title
        }
        validationFunction={validation}
      />
    </div>
  );
}

LocationLinkTitle.propTypes = {
  patchLocationLink: PropTypes.func.isRequired,
  setLastPatchedId: PropTypes.func.isRequired,
  linkItem: PropTypes.object.isRequired,
  patchLocationLinkError: PropTypes.object,
  lastPatchedId: PropTypes.number,
};

LocationLinkTitle.defaultProps = {
  patchLocationLinkError: null,
  lastPatchedId: null,
};

const mapStateToProps = state => (
  {
    patchLocationLinkError: state.locationLinksReducer.patchLocationLinkError,
    lastPatchedId: state.commonReducer.lastPatchedId,
  }
);

export default connect(
  mapStateToProps,
  {
    patchLocationLink,
    setLastPatchedId,
  },
)(LocationLinkTitle);
